import { IApplicationState } from '../types/redux';

export const selectChatsStatistics = (state: IApplicationState) => state.realtorInfo.data?.chatsStatistics;
